document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('[data-product-grid]');
  const toggles = document.querySelectorAll('[data-view-mode-toggle]');

  if (!grid || !toggles.length) return;

  const storageKey = 'collection-view-mode';

  const applyMode = (mode) => {
    grid.setAttribute('data-view-mode', mode);
    document.documentElement.setAttribute('data-view-mode', mode);

    // Sync ALL toggles
    toggles.forEach(toggle => {
      toggle.setAttribute('aria-checked', mode === 'model');
    });
  };

  const savedMode = localStorage.getItem(storageKey) || 'product';
  applyMode(savedMode);

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const current = grid.getAttribute('data-view-mode');
      const next = current === 'model' ? 'product' : 'model';

      localStorage.setItem(storageKey, next);
      applyMode(next);
    });
  });
});